import styled from 'styled-components';
import { colors } from '../../../../../theme/colors';

export const InlineCode = styled.code`
  font-size: 0.875em;
  padding: 1px 2px;
  background-color: ${colors.SURFACE_24DP};
  border-radius: 0.25em;
`;
